import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { connect } from "react-redux";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { createStructuredSelector } from "reselect";
import fetchSelect from "../../effects/fetch-select";
import useFetchDefault from "../../effects/use-fetch-default";
import { setValueEntredBlur } from "../../redux/form/form.actions";
import { selectFormEdit } from "../../redux/form/form.reselect";
import FormFieldError from "../form-field-error/form-field-error.componenet";
import { selectFormTableLatestData } from "../../redux/form/form.reselect";
import './select-filter.componenet.scss';

const SelectFilter = ({
    label,
    type,
    handleChange,
    initialFocus,
    onChange,
    required,
    fieldName,
    partNumber,
    fieldItemName,
    validationProps,
    authToken,
    endpointUrl,
    selectEdit,
    mutliselect,
    disabled,
    defaultValue,
    isDefaultValueFromApi,
    inverted,
    isNotArrayField,
    isSearchable,
    setValueEntredBlur,
    hasDefaultValue,
    defaultValueUrl,
    formEdit,
    noAvailability,
    formLatestData,
    placeholder,
    handleOnChangeSelect,
    allOption,
    defaultOptions,
    ...otherProps
}) => {
    const [defaultValueFromApi, setDefaultValueFromApi] = useState("");

    const { defaultData, defaultError } = useFetchDefault(defaultValueUrl, authToken, hasDefaultValue);

    const customStyles = {
        control: (styles) => ({
            ...styles,
            fontFamily: '"PoppinsRegular", Arial, sans-serif',
            // border: '1px solid #D6D7D8',
            height: '36px',
            minHeight: '36px',
            minWidth: "180px",
            backgroundColor: disabled ? '#FAFAFA' : inverted ? '#FAFAFA' : '#FFFFFF',
            color: disabled ? '#888777' : '#212529',
            textIndent: '10px',
            borderRadius: '12px',
            fontSize: '15px',
            boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.4)',
            textTransform: "capitalize",
            pointerEvents: "auto",
            "&:focus-within": {
                borderColor: "#3084B7"
            },
            "&:hover": {
                cursor: disabled ? "not-allowed" : "pointer"
            }
        }),
        option: (provided, state) => ({
            ...provided,
            fontFamily: '"PoppinsRegular", Arial, sans-serif',
            fontSize: "15px",
            backgroundColor: state.isSelected ? "#F4F5F6" : "",
            borderRadius: "7px",
            marginTop: "3px",
            textTransform: "capitalize",
            color: state.isSelected ? "#111" : null,
            "&:hover": {
                backgroundColor: "#F4F5F6",
            },
        }),
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.7 : 1;
            const color = state.isDisabled ? '#000' : "";
            const transition = 'opacity 300ms';

            return {
                ...provided,
                opacity,
                transition,
                color
            };
        },
        menuPortal: base => ({ ...base, zIndex: 9999 })
    }

    const { control, register, formState: { errors }, setValue } = useFormContext();
    const name = fieldItemName;
    const valueEntered = () => {
        setValueEntredBlur(true)
    }

    const loadOptions = (inputValue) => {
        if (defaultOptions && defaultOptions.length) {
            return new Promise(async (resolve, reject) => {
                resolve([allOption, ...defaultOptions]);
            });
        } else {
            return new Promise(async (resolve, reject) => {
                let options = await fetchSelect(endpointUrl, authToken, inputValue, { location: null, noAvailability: noAvailability ? true : false });
                options = Array.isArray(options) ? options : [];
                resolve([allOption, ...options]);
            });
        }

    };

    useEffect(async () => {
        if (isDefaultValueFromApi) {
            const loadOp = await loadOptions("");
            setDefaultValueFromApi(loadOp[0]);
        }
    }, [])


    useEffect(() => {
        if (!formEdit && Object.keys(defaultData).length && !defaultData.error) {
            setValue(name, [defaultData])
        } else if (!formEdit) {
            setValue(name, defaultValue)
        }
    }, [defaultData])

    const onChangeSelect = (value) => {
        handleOnChangeSelect(value)
    }

    return (
        <div className='select-filter'>

            <Controller
                control={control}
                {...register(name, validationProps)}
                ref={null}
                defaultValue={defaultData.length ? defaultData : defaultValue}
                render={({
                    field: { onChange, onBlur, value, name, ref },
                }) => {
                    return (
                        <AsyncSelect
                            className={`select-filter__select ${errors[fieldName]?.[partNumber]?.[fieldItemName] && 'select-filter__select--error'}`}
                            styles={customStyles}
                            defaultOptions={true}
                            cacheOptions={true}
                            value={value ? value : defaultValueFromApi}
                            onChange={(value) => {
                                onChangeSelect(value);
                                onChange(value);
                                valueEntered();
                            }}
                            loadOptions={loadOptions}
                            isMulti={mutliselect}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            isDisabled={disabled}
                            isSearchable={isSearchable}
                            onBlur={(event) => {
                                valueEntered();
                            }}
                            placeholder={placeholder}
                        />
                    )
                }}
            />
            {errors?.[fieldName]?.[partNumber]?.[fieldItemName] && <FormFieldError errorMessage={errors?.[fieldName]?.[partNumber]?.[fieldItemName].message} />
            }
        </div >
    )
};

const mapStateToProps = createStructuredSelector({
    formEdit: selectFormEdit,
    formLatestData: selectFormTableLatestData,
});

const mapDispatchToProps = dispatch => ({
    setValueEntredBlur: (data) =>
        dispatch(setValueEntredBlur(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(SelectFilter);
